export default {
  methods: {
    getCaptcha() {
      const numOne = Math.round(Math.random() * 20);
      const numTwo = Math.round(Math.random() * 20);
      return {
        numOne: numOne,
        numTwo: numTwo,
        sum: numOne + numTwo
      }
    }
  }
}